module.exports = __webpack_public_path__ + "img/3.557ea1b.jpg";